<molecule-avatar-group
    class="avatar-group-container"
    [avatars]="avatars"
    [size]="size"
    [limit]="limit"
    [fixedWidth]="fixedWidth"
    [forceGroup]="forceGroup"
    [editModalId]="editModalId"
></molecule-avatar-group>
